
import { Component, Vue, Watch } from 'vue-property-decorator';

import attach_module from '@/modules/Attachments';
import plans_module from '@/modules/Plans';

import { TableTemplate } from '@/modules/Attachments/types';
import {
  fieldToLabel,
  ContentColumns,
  ContentTableColumns,
} from '@/modules/Attachments/metadata';

// @ts-ignore
import pdf from 'vue-pdf';

// @ts-ignore
import VuePDFViewer from 'vue-instant-pdf-viewer';
// @ts-ignore
import pdfOjb from '@/pdf/pdfobject.min.js';

// import VueLodash from 'vue-lodash'
// // @ts-ignore
// import lodash from 'lodash'

import Button from 'primevue/button';
import InputText from 'primevue/inputtext';
import InputNumber from 'primevue/inputnumber';

import InputDropdown from '@/components/dropdown/InputDropdown.vue';
import Input from '@/components/input/Input.vue';
import DropdownItem from '@/components/dropdown/parts/DropdownItem.vue';
import ModalCustom from '@/components/modal-custom/index.vue';

Vue.use(pdfOjb);
// Vue.use(VueLodash, { name: 'custom' , lodash: lodash })

Vue.component('Button', Button);
Vue.component('InputText', InputText);
Vue.component('InputNumber', InputNumber);
Vue.component('vue-pdf-viewer', VuePDFViewer);

@Component({
  components: {
    pdf,
    'vue-pdf-viewer': VuePDFViewer,
    ModalCustom,
    DropdownItem,
    InputDropdown,
    Input,
  },
})
export default class File extends Vue {
  public fileContentColumns: Array<TableTemplate> = ContentColumns;

  fileContent: any[] = [];

  public fileId: any = '';
  public fileInfoStr = '';
  public fileInfo: any = false;

  public pdfFile: any = false;
  public onlyPdf: boolean = false;
  pageCount = 1;
  currentPage = 1;
  loadingTask: any;
  plan: any = {};

  openedModal: boolean = false;
  headerImport: string = 'Choose plan and import';
  headerVisit: string = 'Import successful!';
  subheaderVisit: string = 'Do you want to continue with choosen plan?';
  successImport: boolean = false;
  fileTitle: string = 'screener';
  format: string = 'data';
  planid401k: number | null = null;

  displayNewRowDialog: boolean = false;
  tableColumnName = '';
  tableColumnTicker = '';
  tableColumnExpenceRatio = 0;
  tableColumnFullTextInOriginalFile = '';
  tableColumnMarketValue = 0;

  public tableMenu = [
    {
      name: 'Export Data',
      label: 'exportData',
    },
    {
      name: 'Import Data',
      label: 'importData',
    },
  ];
  public manuItem = '';

  public saved = true;

  // @Watch('saved', {immediate: true, deep: true})
  // async onSaved(data: any, oldData: any) {
  //   console.log(">>>>>> streamConfig Change ---> data: ", data)
  //   if (!data) this.saveData()
  // }

  @Watch('fileContent', {immediate: true, deep: true})
  async onTableChange(data: any, oldData: any) {
    console.log(">>>>>> streamConfig Change ---> data: ", data)
    if (data) this.saveData()
  }

  get visit401k() {
    return `https://rixtrema.net/401k/summary?planid=${this.planid401k}&planname=${this.plan.value}&action=open&settings=planoftheweek`;
    console.log('visit401k');

  }

  get visitLEXE() {

   return 'https://rixtrema.net/larkspurexecutive/plan?ackid=' + this.plan.ackid;
  }

  closeModal() {
    this.plan = {};
    this.openedModal = false;
    this.successImport = false;
    this.planid401k = null;
  }

  onSearch = async (searchStr: string) => {

    const serverItems = await plans_module.searchPlans(searchStr);

    const items = serverItems.map((item: any) => {
      return {
        label: item.SPONSOR_DFE_NAME,
        value: item.PLAN_NAME,
        EIN: item.SPONS_DFE_EIN,
        PN: item.SPONS_DFE_PN,
        ackid: item.ACK_ID,
      };
    });

    return new Promise((resolve) => resolve(items));
  };

  async created() {
    // this._ = new lodash()
    // this.fileId = this.$route.params.id;
    this.fileId = this.$route.query.id;

    console.log(">>>>>> (this.$route.query.onlyPDF as string): ", (this.$route.query.onlyPDF as string))

    this.onlyPdf =
      (this.$route.query.onlyPDF as string) &&
      (this.$route.query.onlyPDF as string) === 'true'
        ? true
        : false;
    console.log('>>>>>> this.onlyPdf: ', this.onlyPdf);

    const fileData = await attach_module.getFileData(this.fileId);

    console.log('>>>>>> created ---> fileData: ', fileData);

    this.fileInfoStr = fileData.info;

    try {
      this.fileInfo = JSON.parse(this.fileInfoStr)[0];
      console.log(
        '>>>>>>> this.fileInfo: ',
        this.fileInfo,
        ' , this.fileInfoStr: ',
        this.fileInfoStr,
      );
    } catch (e) {
      console.warn('FAILED TO PARSE FILE INFO: ', e);
    }

    try {
      const data: any = JSON.parse(fileData.dataManual || fileData.data);
      console.log('>>>>> data: ', data);

      const rowRemover = (row: any) => {

        const {TickerSearchSource, ...newRow} = row;

        return newRow;
      }

      const preparedInfos = data.Infos.map(rowRemover);

      this.fileContent = preparedInfos;
      if (preparedInfos) {
        this.fileContentColumns = preparedInfos.length
          ? Object.keys(preparedInfos[0]).map((el: string) => {
            
            const column = {
              field: el,
              header: fieldToLabel(el),
            }

            if (el == 'ExpenceRatio'){
              column.header = fieldToLabel('ExpenseRatio');
            }

            return column;
            
          })
          : ContentColumns;
      } else if (data.length) {

        const newData = data.map(rowRemover);

        this.fileContentColumns = Object.keys(newData[0]).map((el: string) => ({
          field: el,
          header: fieldToLabel(el),
        }));
      }
    } catch (e) {
      console.warn('FILE LOAD CONTENT ERROR: ', e);
      this.pdfFile = await attach_module.getFilePDF({fileId: this.fileId, storageKey: this.fileInfo.StorageKey});
      this.onlyPdf = true

      this.loadingTask = pdf.createLoadingTask(this.pdfUrl);
    }

    if (this.onlyPdf && !this.pdfFile)
      this.pdfFile = await attach_module.getFilePDF({fileId: this.fileId, storageKey: this.fileInfo.StorageKey});

    if (this.pdfUrl){
      const link = document.createElement('a');
      link.href = this.pdfUrl;
      link.download = 'file.pdf';
      link.dispatchEvent(new MouseEvent('click'));
    }

    console.log('>>>>>> this.pdfFile: ', this.pdfFile);
  }

  onChanged(e: any) {
    console.log('-----> cell was changed');
    this.saved = false;
  }

  onSort(e: any) {
    console.log('-----> cell was sorted: ', e);
    this.fileContent = this._.orderBy(
      this.fileContent,
      [e.sortField],
      [e.sortOrder === 1 ? 'asc' : 'desc'],
    );
    this.saved = false;
  }

  saveData() {
    console.log('>>>>>>>>> saveData ---> fileContent: ', this.fileContent);
    console.log('>>>>>>>>> saveData ---> this.fileId: ', this.fileId);
    attach_module.savePDF({
      data: JSON.stringify({ Infos: this.fileContent }),
      Id: this.fileId,
    });
    this.saved = true;
  }

  prepareSize(s: string | number) {
    const b = Number(s);
    return Number(b / 1024 / 1024).toFixed(2) + ' Mb';
  }

  removeRow(el: any) {
    console.log('>>>>>>>>> removeRow ---> bodyProps: ', el);
    this.saved = false;
    this.fileContent.splice(el.index, 1);
  }

  async savePlan() {
    const planposition = this.fileContent.map((fund) => ({
      AnnualER: fund.ExpenceRatio,
      Ticker: fund.Ticker,
      Value: fund.MarketValue,
    }));

    if (this.plan.value) {
      console.log('this.plan', this.plan);

      const FCT = await plans_module.savePlan({
        planposition,
        EIN: this.plan.EIN,
        PN: this.plan.PN,
      });

      if (FCT) {
        this.planid401k = Number(FCT.planid);

        this.$toast.add({
          severity: 'success',
          summary: 'Import',
          detail: `Plan was successfully imported`,
          life: 3000,
        });

        this.successImport = true;
      } else {
        this.$toast.add({
          severity: 'error',
          summary: "Plan didn't saved",
          detail: `Please, try again`,
          life: 3000,
        });
      }
    } else {
      this.$toast.add({
        severity: 'error',
        summary: 'No plan was chosen',
        detail: `Please, choose plan before import`,
        life: 3000,
      });
    }
  }

  importData(e: any) {
    this.openedModal = true;
    console.log('>>>>>>>>> importData ---> fileContent: ', this.fileContent);
  }

  exportCSV(e: any) {
    // @ts-ignore
    this.$refs.dtPDF.exportCSV();
  }

  prepareToAddRow() {
    this.displayNewRowDialog = true;
  }

  prepareLabel(el: any, fild: string){
    if (fild === 'MarketValue') return this.currencyFormat(Number(el))
    if (fild === 'ExpenceRatio') return String(el) + " %"
    return el;
  }

  currencyFormat(price: number) {
    const s = String(price)

    var formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',

      // These options are needed to round to whole numbers if that's what you want.
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });

    return formatter.format(price);
  }

  newRow() {
    this.saved = false;

    // 'Ticker',
    //   'Name',
    //   'ExpenceRatio',
    //   'FullTextInOriginalFile',
    //   'MarketValue',

    const obj =
      this.fileContent && this.fileContent[0]
        ? Object.keys(this.fileContent[0])
        : ContentTableColumns;
    const newRowObj = obj.reduce((pr, cur) => {
      pr[cur] = '---';
      if (cur === 'Ticker') pr[cur] = this.tableColumnTicker;
      if (cur === 'Name') pr[cur] = this.tableColumnName;
      if (cur === 'ExpenceRatio') pr[cur] = this.tableColumnExpenceRatio;
      if (cur === 'FullTextInOriginalFile')
        pr[cur] = this.tableColumnFullTextInOriginalFile;
      if (cur === 'MarketValue') pr[cur] = this.tableColumnMarketValue;
      return pr;
    }, {} as any);

    this.fileContent = [newRowObj, ...this.fileContent];
    console.log('>>>>> newRowObj as new row: ', newRowObj);
    console.log('>>>>> this.fileContent with new row: ', this.fileContent);
    this.displayNewRowDialog = false;
    // this.fileContent.push(newRowObj)
  }

  get pdfUrl() {
    
    // const objUrl = window.URL.createObjectURL(
    //   new Blob([this.pdfFile], { type: 'application/pdf' }),
    // );
    // console.log('>>>>>>>>> objUrl: ', objUrl);
    // return objUrl;
    return this.pdfFile;
  }

  logContent(page: number) {
    console.log('>>>>>>>> start ---> logContent');
    this.currentPage = page;
    //@ts-ignore
    // this.$refs.myPdfComponent.print(page)
    // this.$refs.myPdfComponent.pdf.forEachPage((page:any) => {
    //
    //   return page.getTextContent()
    //     .then((content:any) => {
    //
    //       const text = content.items.map((item:any) => item.str);
    //       console.log(text);
    //     })
    // });
  }
}
